module.exports = __webpack_public_path__ + "img/page.ac191ce0.png";